// IE 2026 09 24 / ODOO-5800 (Igor: «в свободном режиме формы ячейки — поиск / фильтр по её содержимому»): фильтр строк блоков формы-дропдауна по подстроке без учёта регистра.
// Работает по ГОТОВОМУ DOM формы (после отрисовки Vue), а не по данным: строки формы рисуются десятком способов (куски со ссылками, бейджи статусов и сегментов,
// чипы сводок, сетка «подпись / значение» паспорта), и один проход по видимому тексту дешевле и надёжнее, чем повторять эту логику в данных каждого блока.
//  - строка = группа элементов (cellSearch_groups): метрика с её пояснениями, документ-чип, пара «подпись / значение» паспорта с подстроками, правило, формат, чип сводки …;
//  - строка без совпадения получает атрибут data-dd-hide (CSS формы: display none). Атрибут Vue не трогает (его нет в пропсах узла); пересоздание элемента снимает
//    его — после каждой перерисовки фильтр ставится заново (Dropdown.updated);
//  - совпадения в оставшихся строках оборачиваются <mark class="dd-mark"> внутри обёртки <span class="dd-mark-w">, которая ЗАМЕЩАЕТ текстовый узел. Vue держит ссылку
//    на исходный текстовый узел, поэтому перед каждой перерисовкой (Dropdown.beforeUpdate) обёртки снимаются — исходный узел возвращается на место (cellSearch_restore);
//  - SVG (Гант) здесь не трогается: <mark> внутри <text> не рисуется; строки Ганта фильтруются в модели (cellSearch_gantt), график и DOS не фильтруются вовсе.
import { searchLadder, ungroupDigits } from './searchMatch'   // IE 2026 09 24 / ODOO-5800 (Igor: поиск формы — как по таблице): лестница поиска грида, числа без разделителей разрядов

// части формы, где строк нет: шапка, само поле поиска, график (AttrChart + DOS), мини-график, формы легенд, Гант (модель), ручки
// (.dropdown-gantt-main — график + SVG Ганта; колонка запасов .dropdown-policy-col рядом с ними — строки, как у блока DETAILS · STOCK)
const SKIP = '.dropdown-commands, .dropdown-search, .dropdown-cell-chart, .dropdown-mini-chart, .dropdown-legend-pop, .dropdown-gantt-main, .dropdown-handles, svg'
// текст внутри этих узлов не помечается
const NO_MARK = 'svg, input, textarea, select, script, style, [contenteditable]'

// нормализация для сравнения: неразрывные пробелы → пробел, регистр — посимвольно (длина строки не меняется — индексы совпадений переносятся на исходный текст)
export function cellSearch_norm(s) {
    return String(s == null ? '' : s).replace(/[\u00a0\u202f]/g, ' ').split('').map(c => { const l = c.toLowerCase(); return l.length === 1 ? l : c }).join('')
}

const textOf = (els) => cellSearch_norm(els.map(e => e.textContent || '').join(' ')).replace(/\s+/g, ' ')

// строки формы — группы элементов [{ els, sec }] (sec — секция паспорта, в которой живёт строка)
export function cellSearch_groups(root) {
    const out = []
    const skipped = (el) => { const s = el.closest(SKIP); return !!s && s !== root && root.contains(s) }
    const push = (els, sec) => { els = els.filter(Boolean); if (els.length && !skipped(els[0])) out.push({ els, sec: sec || null }) }
    for (const el of root.querySelectorAll('.dropdown-infl')) push([el])                 // формула
    for (const el of root.querySelectorAll('.dropdown-corr-item')) push([el])            // история правки
    // чипы сводок свёрнутых блоков (метрики, форматы), группы сводки документов; сводки-строки (правила, паспорт) — текст без чипов
    for (const el of root.querySelectorAll('.dropdown-blk-sum > .dropdown-blk-chip, .dropdown-docs-sumitem')) push([el])
    for (const el of root.querySelectorAll('.dropdown-blk-sum:not(.dropdown-infl-text):not(.dropdown-docs-sum)')) if (!el.children.length) push([el])
    // метрика + её пояснения (соседи .dropdown-metric-note до следующей метрики)
    for (const el of root.querySelectorAll('.dropdown-metric-item')) {
        const g = [el]; let s = el.nextElementSibling
        while (s && s.classList.contains('dropdown-metric-note')) { g.push(s); s = s.nextElementSibling }
        push(g)
    }
    for (const el of root.querySelectorAll('.dropdown-doc-item')) push([el])             // документы (раскрытый список)
    // паспорт: пара «подпись / значение» + её подстроки («  …» — dropdown-passport-sub); примечание секции. Название секции — ориентир, не строка (как заголовки блоков):
    // прячется только вместе с секцией, когда в ней не осталось строк (cellSearch_apply)
    for (const sec of root.querySelectorAll('.dropdown-passport-section')) {
        for (const grid of sec.querySelectorAll(':scope > .dropdown-passport-grid')) {
            const ch = [...grid.children]; let g = null
            for (let i = 0; i + 1 < ch.length; i += 2) {
                const lab = ch[i], val = ch[i + 1]
                if (g && lab.classList.contains('dropdown-passport-sub')) { g.push(lab, val); continue }
                if (g) push(g, sec)
                g = [lab, val]
            }
            if (g) push(g, sec)
        }
        for (const el of sec.querySelectorAll(':scope > .dropdown-passport-more')) push([el], sec)
    }
    for (const el of root.querySelectorAll('.dropdown-policy-model, .dropdown-policy-norm')) push([el])                         // колонка запасов: модель, нормативы (IE 2026 09 24, п. 4)
    for (const el of root.querySelectorAll('.dropdown-rule, .dropdown-rule-more')) push([el])                                   // правила
    for (const el of root.querySelectorAll('.dropdown-cf-item:not(.dropdown-metric-item):not(.dropdown-rule-item)')) push([el])   // форматы
    return out
}

// снять метки и скрытие: обёртки <span.dd-mark-w> → исходные текстовые узлы, атрибуты data-dd-hide — долой
export function cellSearch_restore(root) {
    if (!root || !root.querySelectorAll) return
    for (const w of root.querySelectorAll('.dd-mark-w')) { const tn = w.__ddText; if (tn) { try { w.replaceWith(tn) } catch (e) { /* узел уже вне DOM */ } } else w.remove() }
    for (const el of root.querySelectorAll('[data-dd-hide]')) el.removeAttribute('data-dd-hide')
    root.__ddSig = ''
}

// пометить совпадения q (нормализованный, непустой) в текстовых узлах элемента
function markIn(el, q) {
    if (el.matches && el.matches(NO_MARK)) return
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, { acceptNode: (n) => {
        const p = n.parentElement; if (!p || p.closest(NO_MARK) || p.classList.contains('dd-mark-w')) return NodeFilter.FILTER_REJECT
        return cellSearch_norm(n.data).includes(q) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
    } })
    const nodes = []; let n
    while ((n = walker.nextNode())) nodes.push(n)
    for (const tn of nodes) {
        const d = tn.data, nd = cellSearch_norm(d), w = document.createElement('span'); w.className = 'dd-mark-w'
        let i = 0, at
        while ((at = nd.indexOf(q, i)) >= 0) {
            if (at > i) w.appendChild(document.createTextNode(d.slice(i, at)))
            const m = document.createElement('mark'); m.className = 'dd-mark'; m.textContent = d.slice(at, at + q.length); w.appendChild(m)
            i = at + q.length
        }
        if (i < d.length) w.appendChild(document.createTextNode(d.slice(i)))
        w.__ddText = tn
        try { tn.replaceWith(w) } catch (e) { /* узел вне DOM */ }
    }
}

// применить фильтр: q — нормализованный запрос ('' — снять всё). Возвращает { n — строк с совпадением, m — строк всего, changed — набор скрытых строк изменился }
export function cellSearch_apply(root, q) {
    if (!root || !root.querySelectorAll) return { n: 0, m: 0, changed: false }
    const prev = root.__ddSig || ''
    cellSearch_restore(root)
    if (!q) return { n: 0, m: 0, changed: prev !== '' }   // пустой запрос — только снять остатки; строки не собираются (updated() зовёт и без поиска)
    const groups = cellSearch_groups(root), m = groups.length
    let n = 0
    const secAlive = new Map()   // секция паспорта → есть ли в ней видимая строка
    for (const g of groups) {
        const hit = textOf(g.els).includes(q)
        if (hit) { n++; for (const el of g.els) markIn(el, q) }
        else for (const el of g.els) el.setAttribute('data-dd-hide', '1')
        if (g.sec) secAlive.set(g.sec, (secAlive.get(g.sec) || false) || hit)
    }
    for (const [sec, alive] of secAlive) {
        if (!alive) { sec.setAttribute('data-dd-hide', '1'); continue }   // секция без единой видимой строки — целиком, с названием
        const ttl = sec.querySelector(':scope > .dropdown-passport-title'); if (ttl && textOf([ttl]).includes(q)) markIn(ttl, q)   // название остаётся ориентиром; совпадение в нём — помечается
    }
    const sig = q + '|' + n + '|' + m
    root.__ddSig = sig
    return { n, m, changed: sig !== prev }
}

// ---- IE 2026 09 24 / ODOO-5800 (Igor: «поиск должен отрабатывать с учетом ошибок и других подходов которые мы используем при поиске в по таблице») ----
// Нечёткий поиск формы (выключатель fe.cellForm.searchFuzzy, дефолт ВКЛ; false — прежняя подстрока cellSearch_apply выше). Решает ЛЕСТНИЦА ПОИСКА ГРИДА
// (utils/searchMatch.searchLadder — тот же порядок ступеней и те же функции сопоставления, что у чипса поиска таблицы): фраза целиком (слова по порядку через
// пробелы) → части в любом порядке (AND по строке; числа словами → цифры) → другая раскладка клавиатуры (EN ↔ RU ↔ UK, смешанный текст) → ступени опечаток
// 1…6 (гласная; одна буква; две буквы; пропуски букв; похожие знаки — дефисы / апострофы выпадают, № ≈ Nº, латиница ≈ кириллица, ё ≈ е; несколько букв).
// Решение — по ВСЕМ строкам формы сразу (строки блоков DOM + строки Ганта, cellSearch_ladder), как грид решает по всем строкам данных: есть результат на
// ступени — дальше не усложняем. Строка формы = строка таблицы, её элементы — ячейки (подпись и значение паспорта, метрика и пояснения): каждая часть — хоть
// в какой-то ячейке. Числа форма показывает с разделителями разрядов, а грид ищет по сырым значениям, — у ячейки с таким числом есть вариант без разделителей
// («1080» находит «1 080»). Подсветка — <mark> на найденном фрагменте; нечёткое совпадение — dd-mark-fuzzy (как wj-state-match-fuzzy грида)

// ячейка строки формы: текст из её текстовых узлов (без svg / полей ввода, регистр и NBSP — cellSearch_norm, длина та же) и где в тексте лежит каждый узел
// (segs — подсветка). Между узлами РАЗНЫХ элементов без пробела на стыке — пробел: бейдж и название правила, тип / номер / статус документа не склеиваются
// в одно слово (textContent прежнего поиска их склеивал)
function cellOf(el) {
    const segs = []
    let text = ''
    if (!el || (el.matches && el.matches(NO_MARK))) return { text, segs }
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, { acceptNode: (n) => {
        const p = n.parentElement; if (!p || p.closest(NO_MARK)) return NodeFilter.FILTER_REJECT
        return n.data ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
    } })
    let n, prevParent = null
    while ((n = walker.nextNode())) {
        const d = cellSearch_norm(n.data)
        if (prevParent && prevParent !== n.parentElement && text && !/\s$/.test(text) && !/^\s/.test(d)) text += ' '
        segs.push({ node: n, start: text.length, end: text.length + d.length })
        text += d
        prevParent = n.parentElement
    }
    return { text, segs }
}

// тексты строки для лестницы: ячейки + варианты ячеек с числами без разделителей разрядов (src[k] — чья ячейка текст k и как вернуть позиции в неё)
function rowTexts(cellTexts) {
    const texts = [], src = []
    cellTexts.forEach((t, i) => { texts.push(t); src.push({ i, map: null }) })
    cellTexts.forEach((t, i) => { const u = ungroupDigits(t); if (u.changed) { texts.push(u.text); src.push({ i, map: u.map }) } })
    return { texts, src }
}

// пометить диапазоны [{ start, end, fuzzy }] текста ячейки (позиции — в тексте cellOf) в её текстовых узлах: обёртка <span.dd-mark-w> замещает узел (как markIn)
function markRanges(cell, ranges) {
    const rs = (ranges || []).filter(r => r && r.end > r.start).sort((a, b) => a.start - b.start)
    if (!rs.length) return
    const merged = []
    for (const r of rs) {
        const last = merged[merged.length - 1]
        if (last && r.start <= last.end) { last.end = Math.max(last.end, r.end); last.fuzzy = last.fuzzy || !!r.fuzzy }
        else merged.push({ start: r.start, end: r.end, fuzzy: !!r.fuzzy })
    }
    for (const sg of cell.segs) {
        const loc = []
        for (const r of merged) { const a = Math.max(r.start, sg.start), b = Math.min(r.end, sg.end); if (a < b) loc.push({ a: a - sg.start, b: b - sg.start, fuzzy: r.fuzzy }) }
        if (!loc.length) continue
        const tn = sg.node, d = tn.data, w = document.createElement('span'); w.className = 'dd-mark-w'
        let i = 0
        for (const x of loc) {
            if (x.a > i) w.appendChild(document.createTextNode(d.slice(i, x.a)))
            const mk = document.createElement('mark'); mk.className = x.fuzzy ? 'dd-mark dd-mark-fuzzy' : 'dd-mark'; mk.textContent = d.slice(x.a, x.b); w.appendChild(mk)
            i = x.b
        }
        if (i < d.length) w.appendChild(document.createTextNode(d.slice(i)))
        w.__ddText = tn
        try { tn.replaceWith(w) } catch (e) { /* узел вне DOM */ }
    }
}

// проверить строку решением лестницы и пометить совпадения: cells — ячейки (cellOf), rt — их тексты (rowTexts). true — строка прошла
function markRow(lad, cells, rt) {
    const rs = lad.testRow(rt.texts)
    if (!rs) return false
    const per = cells.map(() => [])
    rs.forEach((ranges, k) => {
        const s = rt.src[k]
        if (!s || !ranges || !ranges.length) return
        for (const r of ranges) per[s.i].push(s.map ? { start: s.map[r.start], end: s.map[r.end - 1] + 1, fuzzy: r.fuzzy } : r)   // вариант без разделителей — в позиции исходной ячейки
    })
    cells.forEach((c, i) => markRanges(c, per[i]))
    return true
}

// строки Ганта для решения лестницы: документ — ячейки «название / тип / статус / подсказка», строка Ганта — её подпись
function ganttCells(parts) { return rowTexts(parts.filter(Boolean).map(cellSearch_norm)) }
function ganttRows(full) {
    const rows = []
    if (!full) return rows
    for (const it of full.items || []) rows.push(ganttCells([it.title, it.type, it.status, it.tip]).texts)
    for (const ln of full.lanes || []) rows.push(ganttCells([ln.title]).texts)
    return rows
}

// решение лестницы поиска грида по всем строкам формы: domRows — тексты строк DOM (cellSearch_applyFuzzy отдаёт их в decide), full — полная модель Ганта;
// opts.phrase = false — без ступени «фраза целиком» (выключатель грида fe.ux.searchPhraseFirst)
export function cellSearch_ladder(q, domRows, full, opts = {}) {
    return searchLadder([...(domRows || []), ...ganttRows(full)], q, { phrase: opts.phrase !== false, extra: opts.extra !== false })   // IE 2026 10 02 / ODOO-345043 (заказ Игоря: поиск — лишний символ в запросе): opts.extra = false — без последней ступени (fe.search.extraSymbolTier)
}
// ключ решения — сравнить решения двух отрисовок (сработавшая ступень, текст в другой раскладке, фраза, части)
export function cellSearch_ladderKey(lad) {
    if (!lad) return ''
    return [lad.found ? 1 : 0, lad.tier, lad.conv, lad.phrase ? lad.phrase.text : '', (lad.terms || []).join(' ')].join('|')
}

// применить нечёткий поиск: q — нормализованный запрос ('' — снять всё), decide(domRows) → решение лестницы (хозяин добавляет строки Ганта и помнит снимок
// строк DOM для отбора Ганта). Возвращает, как cellSearch_apply, { n, m, changed } и решение lad
export function cellSearch_applyFuzzy(root, q, decide) {
    if (!root || !root.querySelectorAll) return { n: 0, m: 0, changed: false, lad: null }
    const prev = root.__ddSig || ''
    cellSearch_restore(root)
    if (!q) return { n: 0, m: 0, changed: prev !== '', lad: null }   // пустой запрос — только снять остатки; строки не собираются
    const groups = cellSearch_groups(root), m = groups.length
    for (const g of groups) { g.cells = g.els.map(cellOf); g.rt = rowTexts(g.cells.map(c => c.text)) }
    const lad = (typeof decide === 'function' ? decide(groups.map(g => g.rt.texts)) : null) || searchLadder(groups.map(g => g.rt.texts), q)
    let n = 0
    const secAlive = new Map()   // секция паспорта → есть ли в ней видимая строка
    for (const g of groups) {
        const hit = markRow(lad, g.cells, g.rt)
        if (hit) n++
        else for (const el of g.els) el.setAttribute('data-dd-hide', '1')
        if (g.sec) secAlive.set(g.sec, (secAlive.get(g.sec) || false) || hit)
    }
    for (const [sec, alive] of secAlive) {
        if (!alive) { sec.setAttribute('data-dd-hide', '1'); continue }   // секция без единой видимой строки — целиком, с названием
        const ttl = sec.querySelector(':scope > .dropdown-passport-title')   // название — ориентир, не строка: совпадение в нём помечается
        if (ttl) { const c = cellOf(ttl); markRow(lad, [c], rowTexts([c.text])) }
    }
    const sig = 'z|' + q + '|' + cellSearch_ladderKey(lad) + '|' + n + '|' + m
    root.__ddSig = sig
    return { n, m, changed: sig !== prev, lad }
}

// строки Ганта: full — полная модель (passportView.ganttDocsModel / ganttViewModel), q — нормализованный запрос, rebuild(keepIds) — модель по подмножеству сырых
// элементов (по id документа / факт-запаса). Строка остаётся, если совпала её подпись либо название / статус / подсказка одного из её документов; совпавшие
// документы помечены hit (класс gt-search-hit), совпавшие подписи строк — hit у строки. Ось времени та же: окно месяцев не зависит от набора элементов (passportMonths)
export function cellSearch_gantt(full, q, rebuild) {
    const m = full && Array.isArray(full.lanes) ? full.lanes.length : 0
    if (!full) return { model: full, n: 0, m: 0 }
    if (!q) { for (const it of full.items) it.hit = false; for (const ln of full.lanes) ln.hit = false; return { model: full, n: m, m } }   // пометки прошлого запроса — долой (модель кэширована)
    // IE 2026 09 24 / ODOO-5800 (поиск формы — как по таблице): q — нормализованная подстрока (прежний поиск) либо решение лестницы поиска грида (cellSearch_ladder,
    // fe.cellForm.searchFuzzy): документ — строка из ячеек «название / тип / статус / подсказка», подпись строки Ганта — строка из одной ячейки
    const fz = typeof q === 'object'
    const hitIds = new Set(), laneKeep = new Set()
    for (const it of full.items) if (fz ? !!q.testRow(ganttCells([it.title, it.type, it.status, it.tip]).texts) : cellSearch_norm([it.title, it.type, it.status, it.tip].filter(Boolean).join('\n')).includes(q)) { hitIds.add(it.id); laneKeep.add(it.lane) }
    const laneHit = new Set()
    for (const ln of full.lanes) if (fz ? !!q.testRow(ganttCells([ln.title]).texts) : cellSearch_norm(ln.title).includes(q)) { laneKeep.add(ln.key); laneHit.add(ln.key) }
    const n = full.lanes.filter(l => laneKeep.has(l.key)).length
    let model = full
    if (n < m) {
        const keepIds = new Set(full.items.filter(it => laneKeep.has(it.lane)).map(it => it.id))
        // ни одной строки — модель без строк, но не null: в теле Ганта (.dropdown-gantt) живёт и график, он должен остаться (остаётся полоса месяцев, H = HEAD + 2)
        model = (typeof rebuild === 'function' ? rebuild(keepIds) : null) || { ...full, lanes: [], heads: [], items: [], marks: [], links: [], today: null, H: 16 }
    }
    if (model) {
        for (const it of model.items) it.hit = hitIds.has(it.id)
        for (const ln of model.lanes) ln.hit = laneHit.has(ln.key)
    }
    return { model, n, m }
}

export default { cellSearch_norm, cellSearch_groups, cellSearch_apply, cellSearch_restore, cellSearch_gantt, cellSearch_applyFuzzy, cellSearch_ladder, cellSearch_ladderKey }   // IE 2026 09 24 / ODOO-5800: + нечёткий поиск
